interface VesselDataApiData {
  identification: string;
  model: string;
  brand: string;
  version: string;
  vehicle_type: string;
  year_manufacture: string;
}

class VesselData {
  public identification: string;
  public model: string;
  public brand: string;
  public version: string;
  public vehicleType: string;
  public yearManufacture: string;

  public constructor(data: VesselDataApiData = {
    identification: "",
    model: "",
    brand: "",
    version: "",
    vehicle_type: "",
    year_manufacture: "",
  }) {
    this.identification = data.identification;
    this.model = data.model;
    this.brand = data.brand;
    this.version = data.version;
    this.vehicleType = data.vehicle_type;
    this.yearManufacture = data.year_manufacture;
  }

  public formatPayload(): any {
    const trimmedIdentification = this.identification?.trim();

    return {
      identification: trimmedIdentification ? trimmedIdentification : null,
      model: this.model,
      brand: this.brand,
      version: this.version,
      vehicle_type: this.vehicleType,
      year_manufacture: this.yearManufacture,
    };
  }
}

export default VesselData;
